import { createContext } from 'react';
import { DeviceTypeEnum } from '../types/device-type.enum';
import { DeviceType } from '../types/device.type';
import { DeviceSyncContextType } from '../types/device-sync-context.type';
import { UserType } from '../types/user.type';

export const DeviceSyncContext = createContext<DeviceSyncContextType>({
    syncDeviceDataLoading: false,
    syncDevices: (devices: DeviceTypeEnum[], user?: UserType): void => {
        return;
    },
    getDeviceSyncDate: (deviceType: DeviceTypeEnum, user?: UserType) => {
        return undefined;
    },
    updateUserDevices: (devices: Partial<DeviceType>[]): void => {
        return;
    },
});
